import { useState } from 'react';

/**
 * Development-only component for testing Error Boundary
 * Add to any page: <ErrorBoundaryTest />
 */
export function ErrorBoundaryTest() {
  const [shouldThrow, setShouldThrow] = useState(false);

  if (shouldThrow) {
    throw new Error('Test error boundary - this is expected!');
  }

  // Only show in development
  if (!import.meta.env.DEV) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <button
        onClick={() => setShouldThrow(true)}
        className="px-4 py-2 bg-red-600 text-white rounded-lg shadow-lg hover:bg-red-700 transition-colors text-sm font-medium"
      >
        🧪 Test Error Boundary
      </button>
    </div>
  );
}
